<template>
  <div class="wh-chatlist-vh relative" v-show="showContacts">
    <div class="px-4 pt-3 setposition">
      <Search />
      <div
        class="flex justify-between mb-4 w-full items-center"
        v-if="contacts.length > 0"
      >
        <el-checkbox v-model="checkedall" @change="selectall('checked')"
          >Select all</el-checkbox
        >
        <div
          class="flex gap-2 items-center w-4/12 mt-2"
          v-if="checked1.length > 0"
        >
          <vs-button
            type="primary"
            class="bg-primary fsize10 px-2 text-white font-semibold w-full"
            :disabled="!checked1.length"
            @click="addAudiance"
            >Add</vs-button
          >
          <vs-button
            type="secondary"
            class="bg-secondary fsize10 px-2 text-white font-semibold w-full"
            :disabled="!checked1.length"
            >Cancel</vs-button
          >
        </div>
      </div>
    </div>
    <el-checkbox-group v-model="checked1" class="" v-if="contacts.length > 0">
      <div
        class="px-4 flex items-center w-full"
        v-for="(contact, index) in contacts"
        :key="index"
        :class="{ 'bg-f4f5f6': activeChat._id === contact._id }"
        @click="selectContact(contact)"
      >
        <div class="closelabel w-8">
          <el-checkbox :label="contact.phone"></el-checkbox>
        </div>
        <ChatItem :item="contact" />
      </div>
    </el-checkbox-group>
    <div
      v-else
      class="px-4 flex items-center justify-center text-center w-full mt-5"
    >
      No Data
    </div>
  </div>
</template>

<script>
import ChatItem from "./ChatItem";
import Search from "./Search";

import { mapGetters, mapState } from "vuex";

//Styles
import "../../assets/sass/main.scss";
export default {
  components: {
    ChatItem,
    Search,
  },
  data() {
    return {
      checked1: [],
      checked: "",
      checkedall: false,
    };
  },
  watch: {
    windowWidth(val) {
      if (val < 576) {
        this.toggleChat(false);
      } else {
        this.toggleChat(true);
      }
    },
    checked1() {
      if (this.checked1.length > 0) {
        this.checkall = true;
      } else {
        this.checkall = false;
      }
    },
  },
  computed: {
    ...mapGetters("whatsappChat", {
      contacts: "contacts",
      showContacts: "showContacts",
      searchResults: "searchResults",
      filterContact: "filterContact",
      expStatus: "expStatus",
      messages: "messages",
      activeChat: "activeChat",
    }),
    ...mapState("whatsappChat", {
      audiencecheckbox: "audiencecheckbox",
      checktrue: "checktrue",
    }),
    ...mapState("auth", {
      userData: "userData",
    }),
    ...mapState("AgentRouting", {
      assignmono: "assignmono",
      checkStatus: "checkStatus",
      assignStatus: "assignStatus",
      checknumber: "checknumber",
    }),
    ...mapState("admin", {
      login: "login",
    }),
    ...mapState("whatsappChat", {
      refreshPage: "refreshPage",
    }),
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  watch: {
    //     contacts(){
    // this.fetchContacts()
    //     },
    // refreshPage() {
    //   console.log(this.refreshPage == true || this.refreshPage == false);
    //   if (this.refreshPage == true || this.refreshPage == false) {
    //     this.refreshContacts();
    //   }
    // },
    searchResults() {
      if (this.searchResults.length > 0) {
        this.contacts = [];
        this.contacts = this.searchResults;
        console.log(this.contacts, "gygvygvy");
      }
    },
    filterContact() {
      if (this.filterContact.length > 0) {
        this.contacts = [];
        this.contacts = this.filterContact;
      }
    },
  },
  methods: {
    selectall(x) {
      if (this.checkedall == false) {
        this.checked1 = [];
        const payload2 = false;
        this.$store.commit("whatsappChat/HANDLE_CHECKBOX_TRUE", payload2);
        this.$store.commit("AgentRouting/COMMMIT_ALL_NUMBER", this.checked1);

        console.log(this.checknumber, "checknumberchecknumberchecknumber");
      }
      if (this.checkedall == true) {
        this.checked1 = [];
        const payload = true;

        this.$store.commit("whatsappChat/HANDLE_CHECKBOX_TRUE", payload);
        this.contacts.map((val) => {
          this.checked1.push(val.phone);
          // this.contacts.map((x)=>{
          //   console.log(x.phone)
          // })
        });
        this.$store.commit("AgentRouting/COMMMIT_ALL_NUMBER", this.checked1);
        console.log(this.checknumber, "checknumberchecknumberchecknumber");
      }
    },
    async refreshContacts() {
      // alert(this.refreshPage)
      let payload = {};
      if (this.assignmono.length > 0) {
        Object.assign(payload, { number: this.assignmono[0].assignedNumber });
      }
      this.$forceUpdate();
      await this.$store.dispatch("whatsappChat/fetchContacts", payload);

      let payload3 = {
        refreshPage: false,
      };

      await this.$store.commit("whatsappChat/REFRESH_PAGE", payload3);
    },
    async updateChatStatus(phone, status) {
      const payload = {
        number: phone,
        status: status,
      };
      try {
        let { data } = await this.$store.dispatch(
          "AgentRouting/updateChatStatus",
          payload
        );

        await this.assignStatuss();
        if (data.code == 200) {
          this.sucsess("Status Chang Successfully");
        }
      } catch (err) {
        console.log(err);
      }
    },
    checkCurrenttStatus(phone) {
      this.assignStatus.forEach((val) => {
        if (val.number == phone) {
          console.log(val.status, "statusssssssssss");
          this.statuss = val.status;
        }
      });
    },
    CheckGetAssigned(phone) {
      for (let i in this.getassigned.result) {
        for (let numbers in this.getassigned.result[i].assignedNumber) {
          if (this.getassigned.result[i].assignedNumber[numbers] == phone) {
            return true;
          }
        }
      }
    },
    async GetUserMno() {
      try {
        const payload = {
          rmId: this.login._id,
        };
        await this.$store.dispatch("AgentRouting/RMContact", payload);
      } catch (err) {
        console.log(err);
      }
    },
    async addAudiance() {
      console.log(this.checked1, "checked1checked1");
      let payload = [];
      for (let i = 0; i < this.checked1.length; i++) {
        for (let j = 0; j < this.contacts.length; j++) {
          if (this.checked1[i] == this.contacts[j].phone) {
            payload.push({
              name: this.contacts[j].name,
              phone: this.contacts[j].phone.slice(2),
            });
          }
        }
      }

      console.log(payload);
      var data = await this.$store.dispatch(
        "user/addUserFromWhatsapp",
        payload
      );
      console.log(data.data.totalrecord, "dfdfljdsdsdsdsdflkdkfjhkjh");
      if (data.code == 200) {
        if (data.data.totalrecord == 1) {
          if (data.data.available == 1) {
            this.checked1 = [];
            this.$swal({
              text: "Member already exists",
              icon: "success",
              confirmButtonColor: "#830c81",
              // cancelButtonColor: "#d33",
              confirmButtonText: "Okay",
            });
          } else {
            this.checked1 = [];
            this.$swal({
              text: "Successfully Added Member",
              icon: "success",
              confirmButtonColor: "#830c81",
              // cancelButtonColor: "#d33",
              confirmButtonText: "Okay",
            });
          }
        }
        if (data.data.totalrecord > 1) {
          this.checked1 = [];
          this.$swal({
            text: `Out of ${data.data.totalrecord} Record ${data.data.addrecord}  Added`,
            icon: "success",
            confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
        }
      }
    },

    async fetchContacts() {
      console.log("dataaaaaaaa");
      // this.$vs.loading();
      let payload = {};
      if (this.assignmono.length > 0) {
        Object.assign(payload, { number: this.assignmono[0].assignedNumber });
      }

      // if (this.userData.role === "admin") {
      let responce = await this.$store.dispatch(
        "whatsappChat/fetchContacts",
        payload
      );
      console.log(responce, "response");
      // } else {
      //   const payload = {
      //     communityData: {
      //       communityName: this.$community,
      //     },
      //     user:
      //       this.$store.state.user.userMongoID || localStorage.getItem("mid"),
      //   };
      //   await this.$store.dispatch(
      //     "assignedChat/fetchAssignedContacts",
      //     payload
      //   );
      // }

      if (responce) {
        // this.$vs.loading.close();
      }
      this.selectContact(this.contacts[0]);
    },
    async selectContact(contact) {
      await this.$store.dispatch("whatsappChat/setContact", contact);
      if (this.windowWidth < 576) {
        this.toggleChat(true);
      }
    },
    toggleChat(val = false) {
      this.$store.commit("whatsappChat/SHOW_CHATS", val);
      this.$store.commit(
        "whatsappChat/SHOW_CONTACTS",
        this.windowWidth < 576 ? !val : val
      );
    },
    async getAssignedChats() {
      const payload = {
        communityData: {
          communityName: this.$community,
        },
      };
      // let loader = this.$loading.show({});
      try {
        await this.$store.dispatch("assignedChat/fetchAssignedChats", payload);
        // loader.hide();
      } catch (error) {
        if (error) {
          // loader.hide();
        }
      }
    },
    async checkexpstatus() {
      try {
        let phone = [];
        this.contacts.map((val) => {
          phone.push(val.phone);
        });
        const payload = {
          phone: phone,
        };
        await this.$store.dispatch("whatsappChat/checkexpstatus", payload);
      } catch (err) {
        console.log(err);
      }
    },
    async GetAllassignchat() {
      try {
        await this.$store.dispatch("AgentRouting/GetAllassignchat");
      } catch (err) {
        console.log(err);
      }
    },
    async checkChatStatus() {
      const payload = {};
      try {
        await this.$store.dispatch("AgentRouting/checkChatStatus", payload);
      } catch (err) {
        console.log(err);
      }
    },
    async assignStatuss() {
      var phoneno = [];
      this.contacts.map((val) => {
        phoneno.push(val.phone);
      });
      const payload = {
        number: phoneno,
      };
      try {
        await this.$store.dispatch("AgentRouting/assignStatus", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  async mounted() {
    await this.GetUserMno();

    await this.fetchContacts();
    for (let i = 0; i < this.contacts.length; i++) {
      console.log(this.contacts[i].phone, "contactsssssss");
    }

    await this.GetUserMno();

    //  await this.checkexpstatus();
    await this.checkChatStatus();

    await this.assignStatuss();
    await this.GetAllassignchat();
  },
};
</script>
<style>
.closelabel .el-checkbox__label {
  display: none !important;
}
.setposition {
  position: sticky;
  background: #fff;
  z-index: 999;
  width: 100%;
  top: 0px;
}
.mt-80 {
  margin-top: 180px;
}
</style>
